export const MESSAGES = {
    CALCULATION_START: "Calculation for this backtest was started. Wait while it finished to continue editing.",
    CALCULATION_FINISHED: "Calculation for this backtest finished. You can continue editing."
}